// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.login-page {
    background: #616161;
    margin: 0;
    padding: 0;
    min-height: 100vh;
}

.title{
    color: #CA4300;
    display: flex;
    font-weight: bold;
    font-size: 2rem;
    margin-bottom: 24px;
}


`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB","sourcesContent":["body.login-page {\n    background: #616161;\n    margin: 0;\n    padding: 0;\n    min-height: 100vh;\n}\n\n.title{\n    color: #CA4300;\n    display: flex;\n    font-weight: bold;\n    font-size: 2rem;\n    margin-bottom: 24px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
